// extracted by mini-css-extract-plugin
module.exports = {"Select":"zn-IS6s13zfFPY9NTfzLl"};